import { WebData, WebDataSteps } from "@lvt/web-data";
import { Box, Button } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useHistory } from "react-router";

import CameraSection from "@/common/components/ArchivePage/CameraSection/CameraSection";
import { RootState, useSelector } from "@/store/index";
import { CameraOrCabinetMetadata, isCamera } from "@/utilities/types/archive";


import { VideoRequestOverlay } from "../VideoRequestOverlay/VideoRequestOverlay";
import { useStyles } from "./CameraListStyles";


export default function CameraList() {
    const CameraOrCabinetMetadata: WebData<CameraOrCabinetMetadata[]> = useSelector(
        (state: RootState) => state.archives.camerasOrCabinetsMeta,
    );
    const videoSelectionModeActive: boolean = useSelector((state: RootState) => state.archives.videoSelectionMode);
    const accordionWidth: number = useSelector((state: RootState) => state.archives.gridAndAccordionWidth);
    const history = useHistory();

    const isLiveUnitPath = history.location.pathname.includes("/live-unit/");

    // Using canRequestVideo is unreliable and isnt getting updated as the page changes from Archive cabinet history to Live unit history.
    // Captured in https://liveviewtech.atlassian.net/browse/WEB-3645
    // const canRequestVideo: boolean = useSelector((state: RootState) => state.archives.canRequestVideo);

    const classes = useStyles();

    const handleClick = () => history.push("requested-video");

    switch (CameraOrCabinetMetadata.type) {
        case WebDataSteps.NotAsked:
        case WebDataSteps.Loading:
            return (
                <div className={classes.root}>
                    <div>
                        <Skeleton
                            variant={"rect"}
                            className={classes.skeletonContainer}
                            height={800}
                            width={accordionWidth}
                        />
                    </div>
                </div>
            );
        case WebDataSteps.Success:
            return (
                <div className={classes.root}>
                    {videoSelectionModeActive && <VideoRequestOverlay />}
                    {CameraOrCabinetMetadata.payload.map((cameraOrCabinet: CameraOrCabinetMetadata) => {
                        return (
                            <CameraSection
                                key={cameraOrCabinet.record.id}
                                id={cameraOrCabinet.record.id}
                                name={cameraOrCabinet.record.name}
                                presets={cameraOrCabinet.presets}
                                videos={cameraOrCabinet.archivedVideos}
                                notRecordingReason={cameraOrCabinet.record.notRecordingReason}
                                canStream={isCamera(cameraOrCabinet.record)}
                            />
                        );
                    })}

                    {isLiveUnitPath && <Box display="flex" justifyContent="flex-end" marginRight="5%">
                        <Button
                            variant="outlined"
                            className={classes.button}
                            onClick={handleClick}
                            aria-label="previously-requested-videos"
                        >
                            Previously Requested Videos
                        </Button>
                    </Box>}
                </div>
            );
        case WebDataSteps.Error:
            return <div></div>;
    }
}
